<!--
 * @Author: scg
 * @Date: 2021-12-10 14:54:44
 * @LastEditTime: 2022-03-18 09:49:32
 * @LastEditors: scg
 * @Description:
-->
<template>
  <div id="login">
    <div class="login_logo">
      <div class="img">
        <img src="@/assets/img/logosvg.svg" />
      </div>
      <div class="title">{{$t('password.title')}}</div>
    </div>
    <div class="login">
      <div class="language">
      </div>
      <div id="login_lo">
        <div class="title2">{{$t('password.tips1')}}</div>
      </div>

      <div class="login_input">
        <div class="login_input_title">{{$t('password.password')}}</div>
        <input
          autocomplete="off"
          v-model="logins.newpassword"
          :placeholder="$t('Enter your new password')"
          :type="eye !== 1 ? 'text' : 'password'"
          :class="code ? '' : 'error'"
        />
        <img
          v-if="eye"
          @click="eye = (eye + 1) % 2"
          src="@/assets/img/ege1.png"
          class="login_input_eye"
        />
        <img
          v-if="!eye"
          @click="eye = (eye + 1) % 2"
          src="@/assets/img/ege.png"
          class="login_input_eye"
        />
      </div>
      <div class="login_input">
        <!-- <div class="login_input_title">Password</div> -->
        <input
          autocomplete="off"
          v-model="logins.renewpassword"
          :placeholder="$t('Re-enter your new password')"
          :type="eye1 !== 1 ? 'text' : 'password'"
          :class="code1 ? '' : 'error'"
        />
        <img
          v-if="eye1"
          @click="eye1 = (eye1 + 1) % 2"
          src="@/assets/img/ege1.png"
          class="login_input_eye"
        />
        <img
          v-if="!eye1"
          @click="eye1 = (eye1 + 1) % 2"
          src="@/assets/img/ege.png"
          class="login_input_eye"
        />
      </div>
      <div class="login_input">
        <div class="login_input_title">{{$t('password.verification')}}</div>
        <input
          autocomplete="off"
          v-model="logins.captcha"
          :placeholder="$t('Enter your verification code')"
          :class="code2 ? '' : 'error'"
        />
      </div>
      <div class="Tips" v-if="code2 === 0 || code1 === 0 || code === 0">
        {{ msg }}
      </div>
      <div @click="gologin" class="loginButton">{{$t('password.reset')}}</div>
      <router-link :to="{ name: 'account' }" class="login_a"
        >{{$t('password.no')}}
      </router-link>
      <!-- <a href="/#/account" class="login_a">No account? Create one!</a> -->
    </div>
  </div>
</template>

<script>
import { apiUserResetpwd } from '@/api/user'
export default {
  name: 'HelloWorld',
  data () {
    return {
      code: 1,
      code1: 1,
      code2: 1,
      eye: 1,
      eye1: 1,
      logins: {
        email: this.$route.params.email,
        newpassword: '',
        renewpassword: '',
        captcha: ''
      },
      msg: null
    }
  },
  mounted () {},
  methods: {
    gologin () {
      this.code1 = 1
      this.code = 1
      this.code2 = 1
      this.msg = ''
      let reg =
        /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
      if (!reg.test(this.logins.newpassword)) {
        // this.$message(
        //   'Password must be 8 characters long and include at least one uppercase character, one lowercase character, one number and one special character.'
        // )
        this.code = 0
        this.msg = this.$t('password.msg1');

        return false
      }
      if (this.logins.newpassword !== this.logins.renewpassword) {
        this.code1 = 0
        this.code = 0
        this.msg = this.$t('password.msg2');
        return false
      }
      if (!this.logins.captcha) {
        this.code2 = 0
        this.msg = this.$t('password.msg3');
        return false
      }
      this.logins.renewpassword = this.logins.newpassword
      apiUserResetpwd(this.logins).then((adj) => {
        this.code2 = adj.code
        this.msg = adj.msg
        if (this.code2 === 1) {
          this.$router.push({ name: 'login' })
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#login {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: url(./../assets/img/login.png);
  background-size: 100% auto;
  color: #fff;
}
.login_logo {
  position: absolute;
  top: 45%;
  right: 70%;
}
.login_logo .img,
.login_logo .img img {
  width: 170px;
}
.login_logo .title {
  font-size: 16px;
  line-height: 50px;
}
.login {
  width: 500px;
  /* height: 600px; */
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -300px 0 0;
  background: #fff;
  border-radius: 20px;
}
.login .language {
  position: absolute;
  right: 20px;
  top: 20px;
  /* width: 40px;
  height: 20px; */
  overflow: hidden;
}
.login .language .flag {
  border-radius: 8px;
}
.login .language .dow,
.login .language .flag {
  width: 16px;
  height: 16px;
  overflow: hidden;
  float: left;
  position: relative;
  margin: 2px;
}
.login .language img {
  width: 100%;
  height: 100%;
  top: 0;
  position: absolute;
  left: 0;
}
#login_lo {
  width: 360px;
  margin: 0 auto;
  color: #000;
  text-align: left;
}
#login_lo .title {
  font-size: 32px;
  font-weight: 700;
  font-family: Noto Sans;
  margin: 60px 0 30px;
}
#login_lo .title2 {
  font-size: 24px;
  font-weight: 700;
  font-family: Noto Sans;
  line-height: 36px;
  margin: 60px 0 30px;
}
.login_input {
  width: 360px;
  margin: 0 auto;
  padding-bottom: 10px;
  text-align: left;
  position: relative;
}
.login_input .login_input_title {
  font-size: 14px;
  line-height: 30px;
  color: #000;
}
.login_input input {
  height: 48px;
  width: 358px;
  border-radius: 8px;
  border: 1px solid #d5d7db;
  text-indent: 1em;
  font-size: 14px;
  padding: 0;
}
.login_input input:focus {
  border: 1px solid #00eec3;
}
.login_input input.error {
  border: 1px solid #f54545;
}
.login_input_eye {
  position: absolute;
  bottom: 10px;
  right: 16px;
  width: 16px;
  height: 16px;
  bottom: 28px;
}
.loginButton {
  width: 360px;
  height: 50px;
  border-radius: 25px;
  background: #00eec3;
  font-size: 16px;
  font-weight: 700;
  color: #000927;
  line-height: 50px;
  margin: 50px auto;
  -webkit-box-shadow: 0 2px 6px rgba(8, 145, 120, 0.5);
  box-shadow: 0 2px 6px rgba(8, 145, 120, 0.5);
  user-select: none;
}
.Tips {
  width: 360px;
  height: 16px;
  text-align: left;
  color: #f54545;
  font-size: 12px;
  margin: 0 auto 30px;
}
.login_a {
  font-size: 14px;
  text-align: center;
  color: #0080ff;
  display: block;
  margin-bottom: 50px;
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/password.vue